<ng-container *ngIf="dataRepeater && dataRepeater.length > 0; else noCaraBlock">
    <lib-np-repeater-item [treeviewData]="dataRepeater" [caracConfig]="caracConfig.ConfigurationObject"></lib-np-repeater-item>
</ng-container>
<ng-template #noCaraBlock>
    <div class="noCaraText">Aucune information trouvée !</div>
</ng-template>


